"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BasketAction=void 0;var t;(function(e){e.AddMoreItems="AddMoreItems",e.DeleteBasket="DeleteBasket",e.GoToStore="GoToStore"})(t||(exports.BasketAction=t={}));
//# sourceMappingURL=BasketAction.js.map
